import { isString } from 'lodash';
import { SerializableObject, Type } from '../../core';

import { MobizSettingsFound } from '../other/mobiz-settings-found.type';
import { MobizSettingsOrigin } from '../other/mobiz-settings-origin.type';
import { MobizSettingsScope } from '../other/mobiz-settings-scope.type';
import { MobizSettingsKey } from '../other/mobiz-settings.type';

import { MobizSettingsValue } from './mobiz-settings-value.do';

/**
 * Settings are used for storing arbitrary settings in the system.
 *
 * @see mobiz1:Mobiz.Models.DTO.MobizSettings
 */
export class MobizSettings<T extends MobizSettingsValue> extends SerializableObject {
  public id: string;
  public key: MobizSettingsKey;
  public createdUtc: string;
  public modifiedUtc: string;
  public createdBy: string;
  public modifiedBy: string;
  public scope: MobizSettingsScope;
  public scopeId: string;
  /** @deprecated unused and replace by MobizSettings.origin */
  public settingsFound: MobizSettingsFound;
  public value: T;
  public valueSchema: string;
  public valueSchemaVersion: number;
  public origin: MobizSettingsOrigin;

  private readonly type: Type<T>;

  constructor(type: Type<T>) {
    super();
    this.type = type;
  }

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    switch (propertyName) {
      case 'value':
        // for untyped settings, the value will be a string encoded JSON
        const settingsObj = isString(propertyValue) ? JSON.parse(propertyValue as string) : propertyValue;

        // Convert `value` to the proper MobizSettings type.
        const moduleSettings = new this.type();
        moduleSettings.buildFromJSON(settingsObj);
        return moduleSettings;

      default:
        return super.coercePropertyType(propertyName, propertyValue);
    }
  }

}
